import {FC, useEffect, useMemo, useState} from 'react';
import {toast} from 'react-toastify';
//formik
import {useFormikContext} from 'formik';
import {CreateEventFormValues} from '../../formConfiguration';
//store
import {useAppDispatch} from '@/store/hooks';
import {getEventSponsorCategories} from '@/store/organization-event';
//mui
import {Box, Typography} from '@mui/material';
//constants
import {ADD_SPONSOR, SUBTITLE1, TEXT, SPONSORS, ERROR, PRIMARY} from '@/utils/constants';
//icons
import {ReactComponent as PlusIcon} from '@/assets/icons/plus.svg';
//components
import Button from '@/shared/components/Button';
import SponsorsList from './SponsorsList';
//helpers
import {getErrorMessage} from '@/utils/helpers';
//styles
import {eventSponsorsStyle} from './EventSponsors.styles';
import { useGetOrganizationId } from '@/utils/hooks';

const EventSponsors: FC = () => {
	const dispatch = useAppDispatch();
	const organizationId = useGetOrganizationId();

	const {errors, touched} = useFormikContext<CreateEventFormValues>();

	const isEmptySponsors = useMemo(() => errors.sponsors && touched.sponsors, [errors]);

	const [isOpenAddSponsorModal, setIsOpenAddSponsorModal] = useState(false);

	const handleChangeAddSponsorModal = () => setIsOpenAddSponsorModal(!isOpenAddSponsorModal);

	useEffect(() => {
		const getSponsorCategories = async () => {
			try {
				await dispatch(getEventSponsorCategories(organizationId)).unwrap();
			} catch (error) {
				toast.error(getErrorMessage(error));
			}
		};

		getSponsorCategories();
	}, []);

	return (
		<Box sx={eventSponsorsStyle.wrapper}>
			<Typography variant={SUBTITLE1} sx={eventSponsorsStyle.title}>
				{SPONSORS}
			</Typography>

			<Typography sx={eventSponsorsStyle.afterTitle}>
				Add sponsors to display logos and recognition on your event page.
			</Typography>

			<SponsorsList
				isAddModalOpen={isOpenAddSponsorModal}
				onAddModalChange={handleChangeAddSponsorModal}
				isEditMode={false}
			/>

			<Button
				title={ADD_SPONSOR}
				variant={TEXT}
				color={isEmptySponsors ? ERROR : PRIMARY}
				startIcon={<PlusIcon />}
				disableRipple
				sx={eventSponsorsStyle.button}
				onClick={handleChangeAddSponsorModal}
			/>
		</Box>
	);
};

export default EventSponsors;
